const apiUri = 'https://apimilkplan.esteiogestao.com.br/api' // ambiente de produção;
// const apiUri = 'http://127.0.0.1/api' // ambiente local
// const apiUri = 'https://testeapimilkplan.esteiogestao.com.br/api' // ambiente de testes

export const ENV_APP = {
    apiUri,
}
